import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  LabelList,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

const RentByBedChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Box
        sx={{
          height: '256px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#F3F4F6',
          borderRadius: '0.5rem',
          border: '2px dashed #D1D5DB',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            sx={{
              fontSize: '0.875rem',
              color: '#6B7280',
              marginBottom: '0.25rem',
            }}
          >
            No data available
          </Typography>
          <Typography sx={{ fontSize: '0.75rem', color: '#9CA3AF' }}>
            Search for buildings to see rent analysis
          </Typography>
        </Box>
      </Box>
    );
  }

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <Box
          sx={{
            backgroundColor: '#FFFFFF',
            padding: '0.75rem',
            border: '1px solid #E5E7EB',
            borderRadius: '0.5rem',
            boxShadow: 2,
          }}
        >
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, marginBottom: '0.25rem' }}>
            {data.label}
          </Typography>
          <Typography sx={{ fontSize: '0.75rem', color: '#6B7280' }}>
            Median Rent: ${data.median.toLocaleString()}
          </Typography>
          <Typography sx={{ fontSize: '0.75rem', color: '#6B7280' }}>
            {data.count} unit{data.count !== 1 ? 's' : ''}
          </Typography>
        </Box>
      );
    }
    return null;
  };

  return (
    <Box sx={{ height: '300px', width: '100%' }}>
      <ResponsiveContainer width='100%' height='100%'>
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 10,
            left: 10,
            bottom: 10,
          }}
        >
          <CartesianGrid vertical={false} stroke='#E5E7EB' />
          <XAxis
            dataKey='label'
            tickLine={false}
            tickMargin={10}
            axisLine={false}
            tick={{ fontSize: 12, fill: '#6B7280' }}
          />
          <Tooltip
            cursor={false}
            content={<CustomTooltip />}
          />
          <Bar
            dataKey='median'
            fill='#39585C'
            radius={[8, 8, 0, 0]}
          >
            <LabelList
              position='top'
              offset={12}
              fill='#111827'
              fontSize={12}
              fontWeight={500}
              formatter={(value) => `$${value.toLocaleString()}`}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default RentByBedChart;

